const mapOrgAccessUser = (user = {}) => {
  return {
    id: user.id ?? "",
    firstName: user.first_name ?? "",
    lastName: user.last_name ?? "",
    email: user.email ?? "",
    userName: user.user_name ?? "",
    orgId: user.org_id ?? "",
    companyEmail: user.company_email_id ?? "",
    profileImage: user.profile_image ?? "",
    createdBy: user.created_by ?? "",
    createdDate: user.created_date ?? "",
    updatedBy: user.updated_by ?? "",
    updatedDate: user.updated_date ?? "",
    signupStatus: user.signup_status ?? "",
    isActive: user.is_active ?? false,
    userRole: user.user_role ?? "",
    exzeoId: user.exzeo_id ?? "",
    isEmailVerified: user.is_email_verified ?? false,
    timezone: user.timezone ?? "",
    supervisorId: user.supervisor_id ?? "",
  };
};

export const mapOrgAccessResponse = (response = {}) => {
  const usersSource =
    response.users || (response.data && response.data.users) || [];
  const usersArray = Array.isArray(usersSource) ? usersSource : [];
  return {
    users: usersArray.map(mapOrgAccessUser),
  };
};

const mapCommunity = (community = {}) => ({
  id: community.id ?? "",
  accessGivenBy: community.access_given_by ?? "",
  orgId: community.org_id ?? "",
  accessGivenTo: community.access_given_to ?? "",
  createdDate: community.created_date ?? "",
  updatedDate: community.updated_date ?? "",
});

export const mapCommunitiesResponse = (response = {}) => {
  const communitiesSource =
    response.communities || (response.data && response.data.communities) || [];
  const communitiesArray = Array.isArray(communitiesSource)
    ? communitiesSource
    : [];
  return {
    communities: communitiesArray.map(mapCommunity),
  };
};

export const mapRemoveOrgAccessRequest = (communityId, userId) => ({
  id: communityId,
  access_given_to: userId,
});

export const mapProvideOrgAccessRequest = (userId) => ({
  access_given_to: userId,
});
